import constants from "./constants.json";
import { LnFe } from "../../utils/interfaces/cart";

export interface UserDetailsState {
	firstname: string;
	lastname?: string;
	email: string;
	telephone:string;
	jobTitle: string;
	street: string;
	city: string;
	region: string;
	postcode: string;
	attorneySize: number;
	lnfe?: Array<LnFe>;
 }

const UserInformationView = (data: UserDetailsState, view: string = "row") => {

	const checkView = () => {
		if (view !== "col" || data.email.length >= 25) return 'row';
	
		if (data.attorneySize > 1 && data.lnfe?.some((user: LnFe) => user.fe_email.length > 40)) {
			return 'row';
		}
	
		return 'col';
	}
	
	const defaultView = checkView();
	
	return(
		<div className={`px-4 py-4 w-full ${defaultView === "col" ? "lg:flex lg:flex-col xl:flex-row xl:gap-6" : ""}`}>
			<div className={defaultView === "col" ? "basis-1/2 w-full " : ""}>
	
				<h1 className="text-lg font-semibold mb-4">{constants.formSection.formHeading}</h1>
					<div className="flex flex-col flex-shrink-0 gap-2 items-start justify-start text-grey-scale-slate">
					<div className="flex">
						<h3 className="font-semibold mr-2">{constants.savedFormFields.admin.name}:</h3>
						<span className="pii-mask">
							{data.firstname} {data.lastname}
						</span>
					</div>
					<div className="flex">
						<h3 className="font-semibold mr-2">{constants.savedFormFields.admin.email}:</h3>
						<span className="pii-mask">{data.email}</span>
					</div>
					<div className="flex">
						<h3 className="font-semibold mr-2">{constants.savedFormFields.admin.phone}:</h3>
						<span className="pii-mask">{data.telephone}</span>
					</div>
					<div className="flex">
						<h3 className="font-semibold mr-2">{constants.savedFormFields.admin.jobTitle}:</h3>
						<span className="pii-mask">{data.jobTitle}</span>
					</div>
					 
					<div className="w-full">
						<h3 className="font-semibold mr-2 inline">{constants.savedFormFields.admin.address}:</h3>
						<span className="pii-mask break-words inline">{data.street}</span>
					</div>
					<div className="flex">
						<h3 className="font-semibold mr-2">{constants.savedFormFields.admin.city}:</h3>
						<span className="pii-mask">{data.city}</span>
					</div>
					<div className="flex">
            <h3 className="font-semibold mr-2">{constants.savedFormFields.admin.state}:</h3>
            <span className="pii-mask">{data.region}</span>
          </div>
					<div className="flex">
						<h3 className="font-semibold mr-2">{constants.savedFormFields.admin.zipcode}:</h3>
						<span className="pii-mask">{data.postcode}</span>
					</div>
				</div>
			</div>
			<div className={defaultView === "col" ? "xs:w-full md:w-1/2" : ""}>
				{data.attorneySize > 1 && (
					<>
						{defaultView === "row" && <hr className="text-grey-scale-sleet mt-8" />}
						<div className={defaultView === "row" ? `flex flex-wrap w-full gap-2 ` : "w-full"}>
							{data.lnfe &&
								data.lnfe.map((user: LnFe, index: number) => (
									<div key={`additional-user-${index}`} className="w-full mt-8">
										<h1 className="text-lg font-semibold mb-4">
											{constants.formSection.additionalForm.title} {index + 1}
										</h1>
										<div className="flex text-grey-scale-slate leading-loose">
											<h3 className="font-semibold mr-2">{constants.savedFormFields.additionalUser.name}:</h3>
											<span className="pii-mask">
												{user.fe_firstname} {user.fe_lastname}
											</span>
										</div>
										<div className="flex text-grey-scale-slate leading-loose">
											<h3 className="font-semibold mr-2">{constants.savedFormFields.additionalUser.email}:</h3>
											<span className="pii-mask">{user.fe_email}</span>
										</div>
										<div className="flex text-grey-scale-slate leading-loose">
											<h3 className="font-semibold mr-2">{constants.savedFormFields.additionalUser.jobTitle}:</h3>
											<span className="pii-mask">{user.fe_job_title}</span>
										</div>
									</div>
								))}
						</div>
					</>
				)}
			</div>
		</div>
	);
}
	

export default UserInformationView;
